import { ReactElement } from "react";

import { ButtonCentered } from "../Button";
import PopUp from "../PopUp";

export type Props = {
  readonly title: string;
  readonly description: string;
  readonly onClose: () => void;
};

const IntroPopup = ({ title, description, onClose }: Props): ReactElement => (
  <PopUp title={title} description={description} onClose={onClose}>
    <ButtonCentered children="Speel" onClick={onClose} />
  </PopUp>
);

export default IntroPopup;
